import React from 'react';

export const DeleteIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
        <path
            d="M5.5 10.4V12.6H16.5V10.4H5.5ZM11 0.5C4.928 0.5 0 5.428 0 11.5C0 17.572 4.928 22.5 11 22.5C17.072 22.5 22 17.572 22 11.5C22 5.428 17.072 0.5 11 0.5ZM11 20.3C6.149 20.3 2.2 16.351 2.2 11.5C2.2 6.649 6.149 2.7 11 2.7C15.851 2.7 19.8 6.649 19.8 11.5C19.8 16.351 15.851 20.3 11 20.3Z"
            fill="white"
        />
    </svg>
);
